import React from "react";

export default function MySQL_MIN() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_MIN</h1>
      <p>This is the MySQL_MIN component generated from the SQL JSON.</p>
    </div>
  );
}
